import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { ExtensionInstance, IShowDriveSelectorPanelArgs } from '../type';

export abstract class BaseDriveSelectorPanel {
    private extensionInstance: ExtensionInstance;

    public async showDriveSelectorPanel({ config }: IShowDriveSelectorPanelArgs) {
        const extensionInstance = await this.getExtensionInstance();
        extensionInstance?.show({
            hostFileId: SlideDataServices.DocInfoManager()?.padId ?? '',
            ...config,
        });

        return extensionInstance;
    }

    private async getExtensionInstance() {
        if (!this.extensionInstance) {
            this.extensionInstance = await this.loadExtensionInstance();
        }

        return this.extensionInstance;
    }

    protected abstract loadExtensionInstance(): Promise<ExtensionInstance>;
}
